import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  Header,
  Form,
  Radio,
  Loader,
  Dimmer,
  Grid,
  Button,
  Confirm,
} from 'semantic-ui-react';
import {
  getBusinessDetails,
  openUpdateBusinessPackageModal,
  setSelectedBusinessPackage,
  getRecurringPaymentsDetails,
  cancelRecurringPayment,
  closeCancelRecurringPaymentConfirmation,
  openUpdateOwnerPhoneModal,
  setOwnerPhoneInput,
  setOwnerPhoneError,
  openUpdateBusinessEntityModal,
  setBusinessEntityTypeInput,
  setBusinessEntityTypeError,
} from 'state/business/actions';
import UpdateBusinessPackageConfirmationModal from './UpdateBusinessPackageConfirmationModal';
import EditOwnerPhoneModal from './EditOwnerPhoneModal';
import EditBusinessEntityModal from './EditBusinessEntityModal';
import styles from './BusinessDetailSections.module.css';
import { BUSINESS_ENTITY_TYPE_LABELS } from './constant';

export const BusinessProfile = props => {
  const {
    businessDetailsData,
    allBusiness,
    gettingBusinessDetails,
    updatingBusinessPackage,
    dispatch,
    cancelRecurringPaymentConfirmation,
    cancellingRecurringPayment,
  } = props;

  const activeBusiness = businessDetailsData.data;

  useEffect(() => {
    const businessId = allBusiness.data[allBusiness.activeIndex].id;
    dispatch(getBusinessDetails({ businessId }));
    dispatch(getRecurringPaymentsDetails({ businessId }));
  }, [allBusiness.activeIndex, allBusiness.data, dispatch]);

  const handlePackageClick = (e, { value }) => {
    let isEnterprise = true;
    if (value !== 'ENTERPRISE') isEnterprise = false;
    if (businessDetailsData.data.is_enterprise !== isEnterprise) {
      dispatch(setSelectedBusinessPackage(value));
      dispatch(openUpdateBusinessPackageModal());
    }
  };

  const dateTimeFormat = date => {
    const jsonDate = date.toJSON().slice(0, 10);
    return `${jsonDate.slice(8, 10)}/${jsonDate.slice(5, 7)}/${jsonDate.slice(
      0,
      4
    )}`;
  };

  const constructAddress = () => {
    const businessData = businessDetailsData.data;
    let addressString = '';
    if (businessData.address) {
      addressString += businessData.address;
    }

    if (businessData.kecamatan) {
      if (addressString) {
        addressString += `, ${businessData.kecamatan}`;
      } else {
        addressString += businessData.kecamatan;
      }
    }

    if (businessData.city) {
      if (addressString) {
        addressString += `, ${businessData.city}`;
      } else {
        addressString += businessData.city;
      }
    }

    if (businessData.province) {
      if (addressString) {
        addressString += `, ${businessData.province}`;
      } else {
        addressString += businessData.province;
      }
    }

    if (businessData.postal_code) {
      if (addressString) addressString += ` ${businessData.postal_code}`;
    }

    return addressString;
  };

  const handleEditOwnerClick = () => {
    dispatch(setOwnerPhoneInput(businessDetailsData.data.phone || ''));
    dispatch(setOwnerPhoneError(null));
    dispatch(openUpdateOwnerPhoneModal());
  };

  const handleEditBusinessEntityClick = () => {
    dispatch(
      setBusinessEntityTypeInput(
        businessDetailsData.data.business_entity_type || ''
      )
    );
    dispatch(setBusinessEntityTypeError(null));
    dispatch(openUpdateBusinessEntityModal());
  };

  const handleConfirmCancelRecurringPayment = () => {
    const businessId = allBusiness.data[allBusiness.activeIndex].id;

    dispatch(closeCancelRecurringPaymentConfirmation());
    dispatch(
      cancelRecurringPayment(businessId, () =>
        dispatch(getRecurringPaymentsDetails({ businessId }))
      )
    );
  };

  return (
    <>
      <UpdateBusinessPackageConfirmationModal />
      <EditOwnerPhoneModal />
      <EditBusinessEntityModal />
      <Confirm
        open={cancelRecurringPaymentConfirmation}
        confirmButton={{ negative: true, content: 'Confirm' }}
        onConfirm={handleConfirmCancelRecurringPayment}
        onCancel={() => dispatch(closeCancelRecurringPaymentConfirmation())}
        header="Confirm Cancel Recurring Payment"
        content="Are you sure to perform this operation? Any progress cannot be rolled back"
      />
      <Dimmer
        active={
          gettingBusinessDetails ||
          updatingBusinessPackage ||
          cancellingRecurringPayment
        }
      >
        <Loader size="massive">Loading</Loader>
      </Dimmer>
      {businessDetailsData.data && allBusiness.data ? (
        <div>
          <div style={{ position: 'relative' }}>
            <Header as="h3" dividing>
              Business
            </Header>
            <Button
              primary
              size="mini"
              onClick={handleEditBusinessEntityClick}
              style={{
                position: 'absolute',
                top: 0,
                right: 0,
                padding: '4px 10px',
              }}
            >
              Edit
            </Button>
          </div>
          <Grid>
            <Grid.Row style={{ padding: '8px 0px 0px 0px' }}>
              <Grid.Column mobile={7} tablet={6} computer={5}>
                <li className={styles.fieldLabel}>Business ID</li>
              </Grid.Column>
              <Grid.Column mobile={9} tablet={10} computer={11}>
                : {activeBusiness.id}
              </Grid.Column>
            </Grid.Row>
            <Grid.Row style={{ padding: '2px 0px 0px 0px' }}>
              <Grid.Column mobile={7} tablet={6} computer={5}>
                <li className={styles.fieldLabel}>Business Name</li>
              </Grid.Column>
              <Grid.Column mobile={9} tablet={10} computer={11}>
                : {activeBusiness.name}
              </Grid.Column>
            </Grid.Row>
            <Grid.Row style={{ padding: '2px 0px 0px 0px' }}>
              <Grid.Column mobile={7} tablet={6} computer={5}>
                <li className={styles.fieldLabel}>Business Entity</li>
              </Grid.Column>
              <Grid.Column mobile={9} tablet={10} computer={11}>
                :{' '}
                {BUSINESS_ENTITY_TYPE_LABELS[
                  activeBusiness.business_entity_type
                ] || '-'}
              </Grid.Column>
            </Grid.Row>
            <Grid.Row style={{ padding: '2px 0px 0px 0px' }}>
              <Grid.Column mobile={7} tablet={6} computer={5}>
                <li className={styles.fieldLabel}>Address</li>
              </Grid.Column>
              <Grid.Column mobile={9} tablet={10} computer={11}>
                : {constructAddress()}
              </Grid.Column>
            </Grid.Row>
            <Grid.Row style={{ padding: '2px 0px 0px 0px' }}>
              <Grid.Column mobile={7} tablet={6} computer={5}>
                <li className={styles.fieldLabel}>Subscription</li>
              </Grid.Column>
              <Grid.Column mobile={9} tablet={10} computer={11}>
                : {activeBusiness.business_subscription[0]}
              </Grid.Column>
            </Grid.Row>
            <Grid.Row style={{ padding: '2px 0px 0px 0px' }}>
              <Grid.Column mobile={7} tablet={6} computer={5}>
                <li className={styles.fieldLabel}>Registered Date</li>
              </Grid.Column>
              <Grid.Column mobile={9} tablet={10} computer={11}>
                : {dateTimeFormat(new Date(activeBusiness.registered_date))}
              </Grid.Column>
            </Grid.Row>
            <Grid.Row style={{ padding: '2px 0px 0px 0px' }}>
              <Grid.Column mobile={7} tablet={6} computer={5}>
                <li className={styles.fieldLabel}>Expiration</li>
              </Grid.Column>
              <Grid.Column mobile={9} tablet={10} computer={11}>
                : {dateTimeFormat(new Date(activeBusiness.expired_at))}
              </Grid.Column>
            </Grid.Row>
            <Grid.Row style={{ padding: '2px 0px 0px 0px' }}>
              <Grid.Column mobile={7} tablet={6} computer={5}>
                <li className={styles.fieldLabel}>Is Deleted</li>
              </Grid.Column>
              <Grid.Column mobile={9} tablet={10} computer={11}>
                : {activeBusiness.is_deleted.toString()}
              </Grid.Column>
            </Grid.Row>
            <Grid.Row style={{ padding: '2px 0px 8px 0px' }}>
              <Grid.Column mobile={7} tablet={6} computer={5}>
                <li className={styles.fieldLabel}>Package Deal</li>
              </Grid.Column>
              <Grid.Column mobile={9} tablet={10} computer={11}>
                : {activeBusiness.package_deal}
              </Grid.Column>
            </Grid.Row>
          </Grid>
          <div style={{ position: 'relative' }}>
            <Header
              as="h3"
              dividing
              style={{ marginTop: 'calc(2rem - 0.14285714em)' }}
            >
              Owner
            </Header>
            <Button
              primary
              size="mini"
              onClick={handleEditOwnerClick}
              style={{
                position: 'absolute',
                top: 0,
                right: 0,
                padding: '4px 10px',
              }}
            >
              Edit
            </Button>
          </div>
          <Grid>
            <Grid.Row style={{ padding: '8px 0px 0px 0px' }}>
              <Grid.Column mobile={7} tablet={6} computer={5}>
                <li className={styles.fieldLabel}>Owner ID</li>
              </Grid.Column>
              <Grid.Column mobile={9} tablet={10} computer={11}>
                : {activeBusiness.owner_id}
              </Grid.Column>
            </Grid.Row>
            <Grid.Row style={{ padding: '2px 0px 0px 0px' }}>
              <Grid.Column mobile={7} tablet={6} computer={5}>
                <li className={styles.fieldLabel}>Owner Name</li>
              </Grid.Column>
              <Grid.Column mobile={9} tablet={10} computer={11}>
                : {activeBusiness.owner_name}
              </Grid.Column>
            </Grid.Row>
            <Grid.Row style={{ padding: '2px 0px 0px 0px' }}>
              <Grid.Column mobile={7} tablet={6} computer={5}>
                <li className={styles.fieldLabel}>Email</li>
              </Grid.Column>
              <Grid.Column mobile={9} tablet={10} computer={11}>
                : {activeBusiness.owner_email}
              </Grid.Column>
            </Grid.Row>
            <Grid.Row style={{ padding: '2px 0px 0px 0px' }}>
              <Grid.Column mobile={7} tablet={6} computer={5}>
                <li className={styles.fieldLabel}>Phone Number</li>
              </Grid.Column>
              <Grid.Column mobile={9} tablet={10} computer={11}>
                : {activeBusiness.phone}
              </Grid.Column>
            </Grid.Row>
            <Grid.Row style={{ padding: '2px 0px 8px 0px' }}>
              <Grid.Column mobile={7} tablet={6} computer={5}>
                <li className={styles.fieldLabel}>Last Login</li>
              </Grid.Column>
              <Grid.Column mobile={9} tablet={10} computer={11}>
                :{' '}
                {(() => {
                  if (!activeBusiness.last_sign_in_at) return null;
                  return dateTimeFormat(
                    new Date(activeBusiness.last_sign_in_at)
                  );
                })()}
              </Grid.Column>
            </Grid.Row>
          </Grid>

          <Header as="h3" dividing>
            Is Enteprise
          </Header>
          <Form>
            <Form.Field>
              <Radio
                label="No"
                name="radioGroup"
                value="false"
                checked={!activeBusiness.is_enterprise}
                onChange={handlePackageClick}
              />
              <Radio
                label="Yes"
                name="radioGroup"
                value="true"
                checked={activeBusiness.is_enterprise}
                onChange={handlePackageClick}
              />
            </Form.Field>
          </Form>
        </div>
      ) : (
        <></>
      )}
    </>
  );
};

const mapStateToProps = ({ business }) => ({
  businessDetailsData: business.businessDetailsData,
  allBusiness: business.allBusiness,
  updatingBusinessPackage: business.updatingBusinessPackage,
  gettingBusinessDetails: business.gettingBusinessDetails,
  cancelRecurringPaymentConfirmation:
    business.cancelRecurringPaymentConfirmation,
  cancellingRecurringPayment: business.cancellingRecurringPayment,
});

BusinessProfile.propTypes = {
  dispatch: PropTypes.func.isRequired,
  businessDetailsData: PropTypes.object.isRequired,
  allBusiness: PropTypes.object.isRequired,
  updatingBusinessPackage: PropTypes.bool.isRequired,
  gettingBusinessDetails: PropTypes.bool.isRequired,
  cancelRecurringPaymentConfirmation: PropTypes.bool.isRequired,
  cancellingRecurringPayment: PropTypes.bool.isRequired,
};

export default connect(mapStateToProps)(BusinessProfile);
